/*=========================================================================================
  File Name: modulePackageManagementGetters.js
  Description: Package Module Getters
==========================================================================================*/

export default {

  packageByID: (state) => (packageID) => {
    return state.packages.find(p => p.id == packageID);
  } 

}